import React from "react";
import { BsPatchCheckFill } from "react-icons/bs";
import { AiOutlineHtml5 } from "react-icons/ai";
import { DiCss3Full } from "react-icons/di";
import { DiJavascript1,DiAngularSimple } from "react-icons/di";
import { BsBootstrapFill } from "react-icons/bs";
import { DiReact } from "react-icons/di";
import { DiJava,DiNodejs } from "react-icons/di";
import { DiPython } from "react-icons/di";
import { TbCSharp } from "react-icons/tb";
import { DiPhp } from "react-icons/di";
import { SiSpringboot } from "react-icons/si";
import { DiDotnet } from "react-icons/di";
import { DiLaravel } from "react-icons/di";
import "./Experience.css";

const Eperience = () => {
  return (
    <section id="experience">
      <h5>Les compétences que j'ai</h5>
      <h2>Mes experiences</h2>
      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>
            <BsPatchCheckFill /> Frontend Development
          </h3>
          <div className="experience__content">
            <article className="experience__details">
            <AiOutlineHtml5 className="icon" />
              <h4>
                 HTML
              </h4>
              <small className="text-light">Bonne maitrise</small>
            </article>
            <article className="experience__details">
            <DiCss3Full className="icon" />
              <h4>
                {" "}
                 CSS
              </h4>
              <small className="text-light">maitrise</small>
            </article>
            <article className="experience__details">
            <DiJavascript1 className="icon" />
              <h4>
                 JavaScript
              </h4>
              <small className="text-light">Bonne maitrise</small>
            </article>
            <article className="experience__details">
            <BsBootstrapFill className="icon" />
              <h4>
                 Bootstrap
              </h4>
              <small className="text-light">Bonne maitrise</small>
            </article>
            <article className="experience__details">
            <DiReact className="icon" />
              <h4>
                 ReactJS
              </h4>
              <small className="text-light">Bonne maitrise</small>
            </article>
            <article className="experience__details">
            <DiReact className="icon" />
              <h4>
                 React Native
              </h4>
              <small className="text-light">Bonne maitrise</small>
            </article>

            <article className="experience__details">
            <DiAngularSimple className="icon" />
              <h4>
                 Angular
              </h4>
              <small className="text-light">Bonne maitrise</small>
            </article>
          </div>
        </div>
        <div className="experience__backend">
          <h3>
            <BsPatchCheckFill className="icon" /> Backend Developement
          </h3>
          <div className="experience__content">
            <article>
            <DiJava className="icon" />
              <h4>
                 Java
              </h4>
              <small className="text-light">Bonne maitrise</small>
            </article>
            <article className="experience__details">
            <DiPython className="icon" />
              <h4>
                 Python
              </h4>
              <small className="text-light">maitrise</small>
            </article>
            <article className="experience__details">
            <TbCSharp className="icon" />
              <h4>
                CSharp
              </h4>
              <small className="text-light">Bonne maitrise</small>
            </article>
            <article className="experience__details">
            <DiPhp className="icon" /> 
              <h4>
                Php
              </h4>
              <small className="text-light">Bonne maitrise</small>
            </article>
            <article className="experience__details">
            <SiSpringboot className="icon" />
              <h4>
                 SpringBoot
              </h4>
              <small className="text-light">Bonne maitrise</small>
            </article>
            <article className="experience__details">
            <DiDotnet className="icon" /> 
              <h4>
                DotNet
              </h4>
              <small className="text-light">Bonne maitrise</small>
            </article>
            <article className="experience__details">
            <DiLaravel className="icon" />
              <h4>
                 Laravel
              </h4>
              <small className="text-light">Bonne maitrise</small>
            </article>
            <article className="experience__details">
            <DiNodejs className="icon" />
              <h4>
                 NodeJS
              </h4>
              <small className="text-light">Bonne maitrise</small>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Eperience;
